import React from 'react';
import { Icon } from './Icon.js';
export const IconFolderClip = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M19 17V13H22V18C22 19.6569 20.6569 21 19 21C17.3431 21 16 19.6569 16 18V16", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M13.4141 5H23V10H21V7H12.5859L9.58594 4H3V19H13.084C13.2045 19.7182 13.4522 20.3927 13.8037 21H1V2H10.4141L13.4141 5Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconFolderClip.js.map